import { ca } from '@cian/analytics';
import { getPageData, getJKInfo } from './helpers';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { INewbuildingFromTheBuilder } from '../../types/newbuilding/newbuildingFromBuilder';
import { TAnalyticsUser } from '../../types/analytics';

interface ITrackNewbuildingFromTheBuilderParams {
  builders: INewbuildingBuilder[];
  newbuildings: INewbuildingFromTheBuilder[];
  gaLabel: string;
  user: TAnalyticsUser;
  regionId: string | number | null;
}

export function trackNewbuildingFromTheBuilderBlockAppearance({
  builders,
  newbuildings,
  gaLabel,
  user,
  regionId,
}: ITrackNewbuildingFromTheBuilderParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_others_JK',
    label: '',
    ds: 'desktop',
    products: newbuildings.map((newbuilding, position) => getJKInfo(newbuilding, position + 1, 'others_JK')),
    page: {
      ...getPageData(builders[0]),
      customPageURL: gaLabel,
      region: regionId,
    },
    user: {
      ...user,
    },
    modelVersion: '1',
  });
}

interface ITrackTransferToNewbuildingParams {
  index: number;
  builders: INewbuildingBuilder[];
  newbuildings: INewbuildingFromTheBuilder[];
  gaLabel: string;
  user: TAnalyticsUser;
  regionId: string | number | null;
}

export function trackTransferToNewbuildingFromTheBuilder(
  // Для получения элемента по которому был сделан клик в блоке ЖК от застройщика и его позиции в этом блоке
  { index, builders, newbuildings, gaLabel, regionId, user }: ITrackTransferToNewbuildingParams,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_others_JK',
    label: '',
    ds: 'desktop',
    products: [getJKInfo(newbuildings[index], index + 1, 'others_JK')],
    page: {
      ...getPageData(builders[0]),
      customPageURL: gaLabel,
      region: regionId,
    },
    user: {
      ...user,
    },
    modelVersion: '1',
  });
}
